/**
 * Generated by orval 🍺
 * Do not edit manually.
 * API Vila Contábil
 * OpenAPI spec version: v1.0.9
 */

/**
 * Perfil do usuário no escritório. Valores: 0 = Proprietário; 1 = Funcionário; 2 = Cliente; 3 = Declarante.
 */
export type RelationType = typeof RelationType[keyof typeof RelationType];


export const RelationType = {
  /** Proprietário */
  Owner: 0,
  /** Funcionário */
  Employee: 1,
  /** Cliente */
  Client: 2,
  /** Declarante */
  TaxClaimant: 3,
} as const;
